<template>
    <div>
        <div v-if="!richiedibile">
            <Calendario 
                :class="{'multistudio' : studicount > 1, 'd-none d-md-block' : true}" 
                ref="cal"
                :disponibilita="disponibilita"
                :cols="columns"
                :promozioni="promozioni"
                :groupCollapse="true"
                :visibleHoursBeforeHide="visibilehours"
            />
        </div>
        <div v-if="richiedibile" class="calnextdisp w-100 h-100 text-center text-dark d-none d-md-block">
            <div class="calltoaction richiedidisp richiedidispclinica">
                <div class="w-100 d-none d-md-block py-md-2 mb-lg-2 rfs-6 mr-2 mr-lg-0 bg-white nodisptext">Disponibile su richiesta</div>
                <form method="GET" :action="landingUrl" accept-charset="UTF-8" class="d-block">
                    <input name="studio" type="hidden" :value="idStudioP">
                    <input name="prestazione" type="hidden" :value="idPrestazioneP">
                    <button type="submit" class="btn btn-outline-primary text-uppercase">{{ this.studioIsClinica ? 'chiedi appuntamento' : 'richiedi disponibilità' }}</button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Calendario from "./Calendario";
export default {
    components: {
        Calendario,
    },
    props: {
        idMedico: null,
        idPrestazione: null,
        idStudio: null,
        idKeyword: null,
        idClinica: null,
        startFromDate: null,
        idSpecializzazione: null,
        cols: {
            type: Number,
            default: 6
        },
        loaderOffset: {
            type: Number,
            default: 150
        },
        offsetElement: {
            type: String,
            default: '.wrapper-medici'
        },
        studicount: {
            type: Number,
            default: 1
        },
    },
    data() {
        return {
            wasInViewport: false,
            disponibile: false,
            richiedibile: false,
            disponibilita: [],
            startDate: this.startFromDate || moment().add(1, 'days').format('YYYY-MM-DD'),
            landingUrl: '',
            studioIsClinica: false,
            error: false,

            idMedicoP: null,
            idPrestazioneP: null,
            idStudioP: null,
            idKeywordP: null,
            idClinicaP: null,
            idSpecializzazioneP: null,
            firstDisponibilita: '',
            promozioni: [],

            visibilehours: 5,
            columns: this.cols,
        }
    },
    mounted() {
        const alreadyInViewport = this.calendarInViewport();

        window.addEventListener('resize', () => {
            //distinct between mobile, tablet and desktop
            if (window.innerWidth < 360) {
                this.columns = 3;
                this.visibilehours = 2;
            }
            else if (window.innerWidth < 420) {
                this.columns = 4;
                this.visibilehours = 2;
            }
            else if (window.innerWidth < 576) {
                this.columns = 4;
                this.visibilehours = 2;
            }
            else if (window.innerWidth < 992) {
                this.columns = 5;
                this.visibilehours = 3;
            } else {
                this.columns = 5;
                this.visibilehours = 5;
            }
        });

        //call resize
        window.dispatchEvent(new Event('resize'));

        $(window).on('scroll', () => {
            if (!this.wasInViewport && this.calendarInViewport()) {
                this.wasInViewport = true;
                this.updateDisponibilita();
            }
        });

        if (alreadyInViewport) {
            $(window).trigger('scroll');
        }

        this.$watch(v => [v.idMedico, v.idPrestazione, v.idStudio, v.idKeyword, v.idClinica, v.idSpecializzazione, v.cols], val => {
            this.updateDisponibilita();
        });

    },
    methods: {
        updateDisponibilita: function(config = {}, showLoader = false) {
            this.idStudioP = config.studioId || this.idStudio;
            this.idMedicoP = config.idMedico || this.idMedico;
            this.idPrestazioneP = config.idPrestazione || this.idPrestazione;
            this.idKeywordP =  config.idKeyword || this.idKeyword;
            this.idClinicaP =  config.idClinica || this.idClinica;
            this.startDate = config.startDate || this.startDate;
            this.idSpecializzazioneP = config.idSpecializzazione || this.idSpecializzazione;

            const req = {
                idMedico: (this.idClinicaP ? null : this.idMedicoP),
                idStudio: (this.idClinicaP ? null : this.idStudioP),
                idSede: (this.idClinicaP ? this.idStudioP : null),
                idPrestazione: this.idPrestazioneP,
                idKeyword: this.idKeywordP,
                idClinica: this.idClinicaP,
                startDate: this.startDate,
                idSpecializzazione: (this.idClinicaP ? this.idSpecializzazioneP : null)
            };

            const medicoOrClicnia = this.idClinicaP ? 'clinica' : 'medico';
            let apiurl = api_url + 'frontend/' + medicoOrClicnia + '/disponibilita';

            //Get disponibilita medico
            httpRequest(apiurl, req, { showLoader: showLoader }).then(onResult => {

                if (! onResult.result) {
                    this.error = true;
                    this.errorMessage = onResult.message;
                    return;
                }

                let disp = onResult.data.listDisp;
                this.medico = onResult.data.medico;
                this.disponibile = onResult.data.disponibile && disp?.length > 0;

                const mediciRichiedibili = Boolean(this.idClinicaP && onResult.data?.medici?.map(item => item.medicoRichiedibile ?? false).length);
                const medicoRichiedibile = Boolean(onResult.data?.medico?.medicoRichiedibile ?? false);

                this.richiedibile = (mediciRichiedibili || medicoRichiedibile) && !this.disponibile;
                this.studioIsClinica = onResult.data?.medico?.studioIsClinica ?? false;
                this.landingUrl = (onResult.data.clinica ? onResult.data.clinica?.url : onResult.data.medico?.url) ?? '';

                if (! disp?.length || !onResult.data.disponibile || (!disp?.length && mediciRichiedibili)) {
                    this.error = true;
                    this.errorMessage = 'Nessuna disponibilità trovata';
                    this.disponibile = false;
                    this.replaceCallToAction();
                    return;
                }

                this.disponibilita = disp;
                this.firstDisponibilita = this.formatFirstDisp(disp[0]);

                //search for the closest .first-disponibilita and replace the text if different
                this.replaceCallToAction();
                
                //api to be fixed in the future
                this.promozioni = onResult.data.promozioni.filter(promozione => {
                    return promozione.prestazioni.some(prestazione => prestazione.id_studi == onResult.data.studio.ID);
                });

                if (this.promozioni.length) {
                    for(const k in this.promozioni) {
                        this.promozioni[k].datainizio = moment(this.promozioni[k].datainizio);
                        this.promozioni[k].datafine = moment(this.promozioni[k].datafine);
                    }
                }

            }).catch(onError => {
                this.error = true;
                this.errorMessage = onError.message;
                console.log('onError', onError);
            }).finally(() => {
                this.isLoading = false;
                this.wasInViewport = true;
            });
        },
        calendarInViewport: function() {
            const rect = this.$refs?.cal?.$el?.parentElement.getBoundingClientRect() || {};
            
            const dimensions = {
                top: rect.top,
                left: rect.left,
                bottom: rect.bottom,
                right: rect.right,
                height: rect.height,
                width: rect.width,
                innerHeight: window.innerHeight || document.documentElement.clientHeight,
                innerWidth: window.innerWidth || document.documentElement.clientWidth,
            };

            /**
             * consider the start distance of a container
             * and account for an extra element just below the fold
             **/
            this.currentOffset = ($(this.offsetElement)?.offset()?.top || 0) + (this.loaderOffset || 0);

            const topPlusOffset = dimensions.top + this.loaderOffset;
            const bottomMinusOffset = dimensions.bottom - this.currentOffset;

            const result = (
                dimensions.top > 0 &&
                dimensions.bottom > 0 &&
                topPlusOffset >= 0 &&
                dimensions.left >= 0 &&
                (dimensions.bottom - this.currentOffset) <= dimensions.innerHeight &&
                dimensions.right <= dimensions.innerWidth
            );

            return result;
        },
        replaceCallToAction: function() {

            let btnText = 'Prenota';
            let btnclass = 'btn-primary';
            let dispText = this.firstDisponibilita;
            let dispClass = '';

            if (!this.disponibile && this.richiedibile) {
                btnText = this.studioIsClinica ? 'chiedi appuntamento' : 'richiedi disponibilità';
                btnclass = 'btn-outline-primary btn-richiedi-disp btn-no-disp';
                dispText = 'Su Richiesta';
                dispClass = 'nodisp';
            }
            
            const medicorow = $(this.$refs.cal.$el).closest('.medico-row');
            const parent = medicorow.find('.studio-wrapper.active').first();
            const firstDisp = parent.find('.first-disponibilita').first();
            const child = firstDisp.find('span').first();
            const currentText = child.text().trim();
            const prenotaGroup = parent.find('.prenota-group').first();
            const currentBtn = prenotaGroup.find('button').first();

            if (currentText != dispText) {
                child.text(dispText);
            }

            if (currentBtn.text().trim() != btnText) {
                currentBtn.text(btnText).removeClass('btn-primary btn-outline-primary').addClass(btnclass);
                child.html(dispText).addClass(dispClass);
                prenotaGroup.addClass(dispClass);
            }
        },
        formatFirstDisp: function(disp) {
            const giornata = moment(disp.giorno, 'YYYY-MM-DD');
            const giornoLocale = giornata.locale('it').format('ddd');//.replace(/\b\w/g, l => l.toUpperCase());
            const giornoMese = giornata.locale('it').format('DD MMM');//.replace(/\b\w/g, l => l.toUpperCase());
            const oraInizio = disp.listOrari[0].ora_inizio;
            return 'da ' + giornoLocale + ' ' + giornoMese + ' ' + oraInizio;
        },
    },
}
</script>
